import { render, staticRenderFns } from "./AllArticle.vue?vue&type=template&id=50a0a722&scoped=true&"
import script from "./AllArticle.vue?vue&type=script&lang=js&"
export * from "./AllArticle.vue?vue&type=script&lang=js&"
import style0 from "./AllArticle.vue?vue&type=style&index=0&id=50a0a722&prod&lang=scss&scoped=true&"
import style1 from "./AllArticle.vue?vue&type=style&index=1&id=50a0a722&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a0a722",
  null
  
)

export default component.exports